// Textos do app em português (idioma padrão). A versão em inglês está em en.ts, com as mesmas chaves.
export const ptBR = {
  common: {
    appName: "Let's Go Run",
    loading: "Carregando...",
    help: "Precisa de ajuda?",
    language: "Idioma",
    logout: "Sair",
  },
  footer: {
    developedBy: "DESENVOLVIDO POR",
    legalNav: "Documentos legais",
    privacy: "Privacidade",
    terms: "Termos de Uso",
    linkedin: "LinkedIn de Saulo Rangel",
    github: "GitHub de Saulo Rangel",
    email: "Enviar e-mail para Saulo Rangel",
  },
  auth: {
    photoAlt: "",
    heroTitle1: "Seu ritmo, seu plano",
    heroTitle2: "Cada quilômetro te leva mais longe.",
    heroText: "Planos que se adaptam à sua rotina, ao seu corpo e à sua próxima prova: do primeiro 5 km à maratona.",
    plansLabel: "Planos para cada distância",
    tabs: "Acesso à conta",
    tabLogin: "Entrar",
    tabRegister: "Criar conta",
    welcome: "Bom te ver de novo 👋",
    welcomeText: "Entre para ver o treino de hoje e continuar o seu plano.",
    privacyNote: "Seus dados de treino e saúde trafegam criptografados, ficam em cópias de segurança criptografadas e nunca são vendidos.",
    email: "E-mail",
    emailPlaceholder: "voce@exemplo.com",
    password: "Senha",
    passwordPlaceholder: "Digite sua senha",
    forgot: "Esqueci minha senha",
    rememberMe: "Manter conectado neste dispositivo",
    signIn: "Entrar",
    signingIn: "Entrando...",
    noAccount: "Ainda não corre com a gente?",
    createFree: "Criar conta grátis",
    registerTitle: "Crie sua conta",
    name: "Nome completo",
    namePlaceholder: "Como quer ser chamado?",
    newPasswordPlaceholder: "Mínimo de 10 caracteres",
    passwordHint: "Mínimo de 10 caracteres. Evite senhas comuns e partes do seu e-mail.",
    adult: "Declaro que tenho 18 anos ou mais.",
    acceptTerms: "Li e aceito os <terms>Termos de Uso</terms> e a <privacy>Política de Privacidade</privacy>.",
    acceptHealthData: "Autorizo o tratamento dos meus dados de saúde (necessário para os treinos).",
    createAccount: "Criar minha conta",
    creating: "Criando conta...",
    registerDone: "Enviamos um e-mail para confirmar o cadastro. Abra o link para ativar a conta.",
    backToLogin: "Voltar para entrar",
    forgotTitle: "Esqueceu a senha?",
    forgotText: "Sem problema. Informe o e-mail da sua conta e enviamos um link para criar uma nova senha.",
    forgotSubmit: "Enviar link",
    forgotSending: "Enviando...",
    forgotNote: "O link vale por 60 minutos e só pode ser usado uma vez.",
    sentTitle: "Confira seu e-mail",
    sentText:
      "Se existir uma conta com esse e-mail, enviamos um link para criar uma nova senha. Ele vale por 60 minutos.",
    sentSpam: "Não chegou? Veja a caixa de spam ou tente de novo em alguns minutos.",
    sentOther: "Enviar para outro e-mail",
    resetTitle: "Crie uma nova senha",
    resetText: "Escolha uma senha com pelo menos 10 caracteres. Evite senhas comuns e partes do seu e-mail.",
    newPassword: "Nova senha",
    confirmPassword: "Confirmar nova senha",
    repeatPlaceholder: "Repita a senha",
    resetNote: "Ao salvar, você sai de todos os aparelhos e entra de novo com a nova senha.",
    resetSubmit: "Salvar nova senha",
    resetSaving: "Salvando...",
    invalidTitle: "Link inválido ou expirado",
    invalidText: "Este link já foi usado ou passou de 60 minutos. Peça um novo para continuar.",
    requestNew: "Pedir novo link",
    doneTitle: "Senha alterada",
    doneText: "Por segurança, você saiu de todos os aparelhos. Entre com a nova senha.",
    verifyingTitle: "Confirmando seu e-mail...",
    verifiedTitle: "E-mail confirmado",
    verifiedText: "Sua conta está ativa. Entre para responder à entrevista e receber o seu plano de treino.",
    verifyFailTitle: "Não foi possível confirmar",
    verifyFailText: "O link é inválido ou expirou (vale por 24 horas). Informe seu e-mail e enviamos outro.",
    resend: "Reenviar e-mail de confirmação",
    resending: "Enviando...",
    resendDone: "Se houver uma conta aguardando confirmação com esse e-mail, enviamos outro link.",
    spamNote: "Não achou o e-mail? Veja também a caixa de spam ou lixo eletrônico.",
  },
  validation: {
    email: "Informe um e-mail válido.",
    password: "A senha precisa de pelo menos 10 caracteres.",
    passwordRequired: "Informe a senha.",
    name: "Informe seu nome.",
    required: "Necessário para criar a conta.",
    mismatch: "As senhas não conferem.",
    pw: {
      TOO_SHORT: "A senha precisa de pelo menos 10 caracteres.",
      TOO_LONG: "A senha é longa demais.",
      COMMON: "Essa senha é muito comum. Escolha outra.",
      CONTAINS_EMAIL: "A senha não pode conter partes do seu e-mail.",
      TOO_SIMPLE: "A senha é simples demais: misture mais caracteres diferentes.",
    },
  },
  errors: {
    generic: "Algo deu errado. Tente de novo em instantes.",
    INVALID_TOKEN: "Link inválido ou expirado.",
    network: "Sem conexão com o servidor. Verifique sua internet.",
    serverDown: "O servidor não respondeu. Tente de novo em instantes.",
    INVALID_CREDENTIALS: "E-mail ou senha incorretos.",
    EMAIL_NOT_VERIFIED: "Confirme seu e-mail antes de entrar.",
    RATE_LIMITED: "Muitas tentativas. Aguarde um pouco e tente de novo.",
    VALIDATION_ERROR: "Confira os dados informados.",
    WEAK_PASSWORD: "Escolha uma senha mais forte: evite senhas comuns e partes do seu e-mail.",
    ACCOUNT_LOCKED: "Conta bloqueada por alguns minutos após várias tentativas. Tente mais tarde.",
    UNDERAGE: "O Let's Go Run é só para maiores de 18 anos.",
    INTERVIEW_INCOMPLETE: "Faltam etapas da entrevista.",
    UNAUTHORIZED: "Sua sessão terminou. Entre de novo.",
  },
  interview: {
    title: "Sua entrevista",
    stepOf: "Etapa {{current}} de {{total}}",
    saveNote: "Suas respostas são salvas a cada etapa. Você pode sair e continuar depois.",
    progress: "Progresso da entrevista",
    back: "Voltar",
    next: "Continuar",
    saving: "Salvando...",
    finish: "Concluir entrevista",
    finishing: "Montando seu plano...",
    yes: "Sim",
    no: "Não",
    loadError: "Não foi possível carregar a entrevista.",
    retry: "Tentar de novo",
    errors: {
      required: "Responda este campo.",
      invalid: "Confira este valor.",
    },
    underage: {
      title: "O Let's Go Run é só para maiores de 18 anos",
      text: "Pelas regras do app, não conseguimos montar um plano para quem tem menos de 18 anos. Seus dados não serão usados. Se quiser, você pode excluir a conta agora.",
      password: "Sua senha, para confirmar a exclusão",
      delete: "Excluir minha conta",
      deleting: "Excluindo...",
    },
    steps: {
      basicos: {
        name: "Dados básicos",
        title: "Vamos começar por você",
        text: "Poucos dados para calcular seu nível e proteger sua saúde.",
      },
      triagem: {
        name: "Saúde",
        title: "Triagem de saúde",
        text: "É a etapa de segurança mais importante. Responda com sinceridade.",
      },
      historico: {
        name: "Corrida",
        title: "Sua corrida até agora",
        text: "Usamos isso para escolher o ponto de partida do seu plano. Na dúvida, informe o valor mais conservador.",
      },
      lesoes: {
        name: "Lesões",
        title: "Lesões e dores",
        text: "Dor e lesão mudam o que é seguro treinar. O app não faz diagnóstico: com dor, procure um profissional de saúde.",
      },
      objetivo: {
        name: "Objetivo",
        title: "Seu objetivo",
        text: "O que você quer com a corrida? O plano é montado a partir disso.",
      },
      disponibilidade: {
        name: "Tempo",
        title: "Sua disponibilidade",
        text: "Só planejamos treinos nos dias e no tempo que você informar.",
      },
      recuperacao: {
        name: "Recuperação",
        title: "Recuperação e rotina",
        text: "Sono, estresse e rotina também contam para a carga que o seu corpo aguenta.",
      },
      recursos: {
        name: "Recursos",
        title: "O que você tem à mão",
        text: "Última etapa. Isso só ajuda a adaptar os treinos ao seu dia a dia.",
      },
    },
    basicos: {
      birthMonth: "Mês de nascimento",
      birthMonthPlaceholder: "Escolha o mês",
      birthYear: "Ano de nascimento",
      birthYearHint: "Só mês e ano: guardamos o mínimo necessário.",
      sex: "Sexo",
      sexM: "Masculino",
      sexF: "Feminino",
      sexNone: "Prefiro não informar",
      heightCm: "Altura (cm)",
      weightKg: "Peso (kg) — opcional",
    },
    triagem: {
      intro: "Sobre este questionário",
      note: "Este é o PAR-Q+ oficial. Você não precisa escrever suas condições nem seus medicamentos: guardamos só as respostas Sim e Não. Isto não é diagnóstico e não substitui avaliação profissional.",
      english: "O PAR-Q+ é mostrado na versão original em inglês, publicada pela PAR-Q+ Collaboration, sem alterações.",
      pregnant: "Você está grávida neste momento?",
      pregnantHint: "Pergunta do app, fora do PAR-Q+. Com gravidez, o treino fica adiado até a orientação de um profissional de saúde.",
      attribution: "Fonte",
    },
    historico: {
      monthsRegular: "Há quantos meses você corre com regularidade?",
      monthsRegularHint: "Pelo menos 1 vez por semana, sem pausas longas. Se ainda não corre, informe 0.",
      weeklySessions: "Quantas vezes por semana você correu, em média, nas últimas 4 semanas?",
      weeklySessionsHint: "Pode usar decimais, como 2,5. Se não correu, informe 0.",
      volumeUnit: "Como prefere informar o volume semanal?",
      unitKm: "Em quilômetros",
      unitMin: "Em minutos",
      volumeKm: "Volume semanal médio (km) nas últimas 4 semanas",
      volumeMin: "Volume semanal médio (minutos) nas últimas 4 semanas",
      longestRecentKm: "Maior distância que você correu de uma vez, recentemente (km)",
      longestRecentKmHint: "Se não correu, informe 0.",
      canRunMinutes: "Por quantos minutos você consegue correr sem parar?",
      canRunMinutesHint: "Em ritmo confortável, sem caminhar. Se ainda não consegue, informe 0.",
      daysSinceLastRun: "Há quantos dias foi a sua última corrida?",
      daysSinceLastRunHint: "Hoje é 0.",
      half: "Você completou uma meia maratona (21 km) nos últimos 3 meses?",
      regular: "Nos últimos 3 meses, você fez exercício planejado de pelo menos 30 minutos, em intensidade moderada, em 3 dias ou mais por semana?",
      timesTitle: "Tempos recentes (opcional)",
      timesHint: "Se você correu uma prova ou um teste recente, informe o tempo. Deixe em branco se não tiver.",
      t5k: "Tempo em 5 km",
      t10k: "Tempo em 10 km",
      minutes: "Minutos",
      seconds: "Segundos",
      date: "Data",
    },
    lesoes: {
      injury12m: "Você teve alguma lesão nos últimos 12 meses?",
      runningInjury3m: "Você teve alguma lesão causada pela corrida nos últimos 3 meses?",
      persistent6w: "Você teve lesão ou dor persistente nas últimas 6 semanas?",
      painNow: "Qual a intensidade da dor que você sente hoje?",
      painScale: "0 = nenhuma dor; 10 = a pior dor possível.",
      painPart: "Onde dói? (opcional)",
      painPartHint: "Por exemplo: joelho direito, panturrilha.",
    },
    objetivo: {
      goal: "Qual é o seu objetivo?",
      goals: {
        saude: "Saúde e bem-estar",
        emagrecimento: "Emagrecimento",
        primeira_prova: "Minha primeira prova",
        melhorar_tempo: "Melhorar meu tempo",
      },
      raceDistance: "Qual a distância da prova?",
      raceDate: "Data da prova (opcional)",
      raceDateHint: "Se ainda não escolheu, deixe em branco.",
      // "Melhorar meu tempo" não exige prova marcada: a distância define o plano; a data é opcional.
      timeDistance: "Em qual distância você quer melhorar seu tempo?",
      timeDate: "Tem uma prova marcada? Informe a data (opcional)",
      timeDateHint: "Se não tiver, deixe em branco.",
    },
    disponibilidade: {
      daysPerWeek: "Em quantos dias por semana você pode treinar?",
      minutesPerSession: "Quanto tempo você tem por treino (minutos)?",
      minutesHint: "Entre 10 e 300 minutos.",
      longRunDay: "Qual dia é melhor para o treino mais longo?",
      longRunPlaceholder: "Escolha o dia",
    },
    recuperacao: {
      sleepHours: "Quantas horas você dorme por noite, em média?",
      sleepHint: "Entre 3 e 12 horas. Pode usar decimais, como 7,5.",
      stress: "Como está o seu nível de estresse no dia a dia?",
      stressLevels: {
        "1": "Muito baixo",
        "2": "Baixo",
        "3": "Médio",
        "4": "Alto",
        "5": "Muito alto",
      },
      workType: "Como é o seu trabalho?",
      work: {
        sedentario: "Sedentário (a maior parte do dia sentado)",
        misto: "Misto (em pé e sentado)",
        fisico: "Físico (esforço durante o dia)",
      },
      otherSports: "Quantos minutos por semana você faz outros esportes?",
      otherSportsHint: "Some tudo, sem contar a corrida. Se não faz, informe 0.",
      strength: "Você faz treino de força (musculação ou similar)?",
    },
    recursos: {
      hrDevice: "Você usa algum aparelho para medir a frequência cardíaca?",
      hr: { nenhum: "Nenhum", relogio: "Relógio", cinta: "Cinta" },
      track: "Você tem acesso a uma pista de corrida?",
      treadmill: "Você tem acesso a uma esteira?",
      terrain: "Em que terreno você costuma correr?",
      terrainHint: "Marque todos que valem. Pode deixar em branco.",
      terrains: { plano: "Plano", subidas: "Subidas", trilha: "Trilha" },
    },
  },
  result: {
    title: "Seu perfil de corredor",
    intro: "Veja como você foi classificado e o que isso significa para o seu plano.",
    loadError: "Não foi possível carregar o seu perfil.",
    frequencyTitle: "Frequência na semana",
    levelTitle: "Seu nível",
    levels: { iniciante: "Iniciante", intermediario: "Intermediário", avancado: "Avançado" },
    nextEvaluation: "Próxima reavaliação: {{date}}.",
    screeningTitle: "Triagem de saúde",
    validUntil: "A liberação vale até {{date}}.",
    disclaimer: "Isto não é diagnóstico nem substitui avaliação profissional.",
    officialText: "Recomendações do PAR-Q+",
    officialEnglish: "O texto acima é a versão original em inglês do PAR-Q+ (PAR-Q+ Collaboration, 2025), sem alterações.",
    states: {
      LIBERADO: { title: "Triagem concluída", text: "Pelas suas respostas, você pode começar a treinar, de forma gradual." },
      LIBERADO_APOS_AVALIACAO: {
        title: "Liberado após avaliação",
        text: "Você registrou uma avaliação profissional sem restrições.",
      },
      AVALIACAO_NECESSARIA: {
        title: "Antes de começar, procure mais orientação",
        text: "Suas respostas indicam que é melhor conversar com um médico ou com um profissional de educação física qualificado antes de treinar. Por isso, nenhum treino foi gerado por enquanto.",
      },
      ADIADO: {
        title: "Treino adiado",
        text: "Pelas suas respostas, é melhor esperar antes de treinar. Nenhum treino foi gerado por enquanto.",
      },
      EXPIRADO: {
        title: "Triagem vencida",
        text: "Sua triagem venceu ou sua saúde mudou. Refaça a entrevista para continuar.",
      },
      NAO_FEITA: { title: "Triagem pendente", text: "Conclua a entrevista para ver o seu resultado." },
    },
    reasons: {
      gravidez: "Gravidez informada.",
      sintoma_geral: "Você respondeu Sim a uma pergunta sobre sintomas (dor no peito, tontura ou orientação de atividade supervisionada).",
      seguimento_sim: "Você respondeu Sim a uma das perguntas adicionais sobre problemas de saúde.",
      avaliacao_com_restricoes: "A avaliação informada indicou restrições, e o app ainda não consegue respeitá-las.",
      avaliacao_sem_restricoes: "Após a avaliação, os treinos ficam em intensidade leve a moderada, a não ser que a liberação inclua exercício vigoroso.",
      "45_sem_exercicio_regular": "Com 45 anos ou mais e sem exercício regular recente, os treinos começam leves, até você consultar um profissional de educação física.",
      validade_vencida: "O prazo da liberação terminou.",
      saude_mudou: "Você informou uma mudança na sua saúde.",
    },
    evaluation: {
      title: "Já foi avaliado por um profissional?",
      text: "Se um médico ou profissional de educação física qualificado avaliou você, registre o resultado para liberar os treinos. Não pedimos nenhum documento.",
      eparmedx: "ePARmed-X+ (www.eparmedx.com)",
      result: "Resultado da avaliação",
      results: {
        sem_restricoes: "Liberado, sem restrições",
        com_restricoes: "Liberado, com restrições",
        encaminhado_ao_medico: "Encaminhado ao médico",
        nao_liberado: "Não liberado",
      },
      date: "Data da avaliação",
      source: "Quem avaliou",
      sources: {
        eparmedx: "ePARmed-X+",
        medico: "Médico",
        profissional_educacao_fisica: "Profissional de educação física",
      },
      vigorous: "A liberação inclui expressamente exercício vigoroso.",
      submit: "Registrar avaliação",
      saving: "Registrando...",
      placeholder: "Escolha",
      stillBlocked: "Registramos a avaliação. Com esse resultado, os treinos continuam bloqueados.",
    },
    planTitle: "Seu plano",
    planObjective: "Objetivo",
    objectives: { saude: "Saúde e bem-estar", "5k": "Prova de 5 km", "10k": "Prova de 10 km", "21k": "Meia maratona (21 km)", "42k": "Maratona (42 km)" },
    planLevel: "Nível do plano",
    planLength: "{{weeks}} semanas",
    planBase: "+ {{weeks}} de base antes do modelo",
    planDates: "{{start}} a {{end}}",
    planStart: "Início e fim",
    planEntry: "Onde você começa",
    placement: {
      declarado: "Etapa {{etapa}} da corrida e caminhada, pelo que você disse que já consegue correr sem parar.",
      teto_de_volume:
        "Etapa {{etapa}} da corrida e caminhada. Você já corre mais do que isso sem parar, mas o total da semana não pode crescer de uma vez, então a semana começa aqui.",
      default: "Etapa {{etapa}} da corrida e caminhada, o começo, no ritmo mais cuidadoso. Você avança conforme for se sentindo.",
    },
    planNone: "Ainda não há plano. Quando a triagem permitir, o plano será montado automaticamente.",
    toPanel: "Ir para o painel",
    redo: "Refazer a entrevista",
  },
  settings: {
    title: "Perfil e configurações",
    link: "Configurações",
    loadError: "Não foi possível carregar as configurações.",
    accountTitle: "Conta",
    photoAdd: "Enviar foto",
    photoChange: "Trocar foto",
    photoRemove: "Remover foto",
    photoInput: "Escolher uma foto de perfil",
    photoHint: "Opcional. A foto é reduzida no seu aparelho antes de ser enviada e só você a vê.",
    photoErrors: {
      type: "Use uma imagem JPEG, PNG ou WebP.",
      size: "A imagem é grande demais (máximo de 10 MB).",
      decode: "Não foi possível abrir essa imagem. Tente outra.",
      too_big: "Não foi possível reduzir essa imagem o bastante. Tente outra.",
    },
    nameSave: "Salvar nome",
    nameSaved: "Nome salvo.",
    emailChange: "Trocar e-mail",
    emailExplain:
      "Enviamos um link para o novo endereço. O e-mail da conta só muda quando você abrir esse link; depois disso, será preciso entrar de novo.",
    newEmail: "Novo e-mail",
    currentPassword: "Sua senha atual",
    emailSend: "Enviar link de confirmação",
    emailSent: "Se o endereço {{email}} puder receber, enviamos o link de confirmação. O e-mail só muda depois que você abri-lo.",
    cancel: "Cancelar",
    name: "Nome",
    email: "E-mail",
    language: "Idioma do app",
    devicesTitle: "Aparelhos conectados",
    devicesText: "Se não reconhecer um aparelho, encerre a sessão dele.",
    thisDevice: "Este aparelho",
    lastSeen: "Último acesso: {{date}}",
    endSession: "Encerrar",
    unknownDevice: "Aparelho desconhecido",
    healthTitle: "Saúde e treino",
    screeningLink: "Ver triagem de saúde e plano",
    nextEvaluation: "Próxima reavaliação: {{date}}.",
    redoTitle: "Refazer a entrevista",
    redoText: "Recalcula o seu nível e monta um novo plano. O plano atual é encerrado. Use quando a sua rotina, a sua saúde ou o seu objetivo mudarem.",
    redoCta: "Refazer a entrevista",
    pauseTitle: "Pausar os treinos",
    pauseText: "Se está com dor, lesão ou doença, pause. A corrida só volta depois que você registrar a liberação de um profissional de saúde, e a volta é gradual.",
    pauseCause: "O que aconteceu?",
    causes: { dor: "Dor", lesao: "Lesão", doenca: "Doença" },
    pauseCta: "Pausar os treinos",
    pausing: "Pausando...",
    pauseActive: "Treinos pausados por {{cause}} desde {{date}}.",
    pauseDone: "Liberação registrada em {{date}}. A volta é gradual.",
    clearanceTitle: "Registrar liberação profissional",
    clearanceText: "Se um médico ou profissional de saúde qualificado avaliou e liberou você para voltar a correr, registre a data. Não pedimos nenhum documento.",
    clearanceDate: "Data da avaliação",
    clearanceCta: "Registrar liberação",
    clearanceSaving: "Registrando...",
    dataTitle: "Seus dados",
    dataText: "Seus dados de saúde são sensíveis. Você pode baixar uma cópia ou apagar tudo quando quiser.",
    exportCta: "Baixar meus dados",
    exporting: "Preparando...",
    exportError: "Não foi possível baixar os dados.",
    deleteTitle: "Excluir minha conta",
    deleteText: "Apaga de verdade a sua conta e todos os seus dados: entrevista, triagem, plano, check-ins, treinos e dor. Não dá para desfazer. Baixe uma cópia antes, se quiser.",
    deleteOpen: "Excluir minha conta",
    deletePassword: "Sua senha, para confirmar",
    deleteSure: "Entendo que isso não pode ser desfeito.",
    deleteCta: "Excluir tudo agora",
    deleting: "Excluindo...",
    deleteCancel: "Cancelar",
  },
  lighter: {
    text: "Não está 100% hoje, mas sem dor nem mal-estar? Você pode pedir um treino mais leve.",
    cta: "Não estou 100% hoje",
    onText: "Você pediu um dia mais leve: o treino de hoje ficou 20% mais curto e sem trechos fortes.",
    undo: "Desfazer e voltar ao treino do plano",
  },
  pause: {
    title: "Pausa planejada",
    tag: "Pausa planejada",
    text: "Vai viajar ou tirar uns dias? Marque a pausa antes. Nesses dias não há treino nem lembrete, e eles não contam como treinos perdidos. Pausa por dor, lesão ou doença fica em Configurações.",
    start: "Primeiro dia sem treino",
    end: "Último dia sem treino",
    save: "Marcar pausa",
    update: "Salvar novas datas",
    cancel: "Cancelar a pausa",
    end_now: "Encerrar a pausa hoje",
    saved: "Pausa salva.",
    current: "Pausa de {{start}} até {{end}}.",
    started: "Você está em pausa até {{end}}. Dá para mudar só a data de volta.",
    noticeUpcoming: "Pausa planejada de {{start}} até {{end}}.",
    noticeActive: "Você está em pausa planejada até {{end}}.",
    noticeLink: "Ver ou mudar a pausa",
    returnTitle: "Como fica a volta",
    returnNote: "Contando que você treine até a véspera da pausa. Se parar antes, a volta segue os dias reais sem correr.",
    return: {
      segue: "O plano segue normal.",
      congela: "O plano repete o volume da última semana antes de voltar a subir.",
      reduzido: "Você volta com 70% do volume e sem treinos muito fortes por 2 semanas.",
      longa: "Você volta com metade do volume (ou o começo do seu nível, se for menos), sem treinos muito fortes por 2 semanas. Se a triagem de saúde tiver vencido, o app pede para refazê-la.",
    },
    errors: {
      date_in_past: "Escolha hoje ou uma data futura.",
      after_plan_end: "A pausa não pode passar do fim do seu plano.",
      pause_started: "A pausa já começou: só dá para mudar a data de volta.",
      no_plan: "Você ainda não tem um plano.",
      order: "O último dia vem depois do primeiro.",
    },
  },
  move: {
    title: "Trocar o dia",
    text: "Não dá para treinar nesse dia? Você pode passar este treino para outro dia desta semana.",
    cta: "Escolher outro dia",
    pick: "Para qual dia?",
    cancel: "Cancelar",
    rules: "Só aparecem os dias que mantêm o descanso que o seu plano precisa: treino forte nunca em dias seguidos e, no começo, um dia livre entre as corridas.",
    none: "Nesta semana não há outro dia que mantenha o descanso entre os treinos. Se não der para treinar, marque como não feito.",
    done: "Pronto. O treino passou para {{date}}.",
    blocked: {
      generic: "Não dá para passar o treino para esse dia.",
      dia_ocupado: "Esse dia já tem outro treino.",
      corridas_seguidas: "Nesse dia ficariam duas corridas seguidas, e o seu plano ainda pede um dia livre entre elas.",
      qualidade_seguida: "Nesse dia ficariam dois treinos fortes seguidos.",
      forca_com_sessao_dura: "O treino de força não fica no mesmo dia de um treino forte de corrida.",
      forca_sem_intervalo: "Os treinos de força precisam de dois dias de intervalo entre eles.",
      fora_da_semana: "Só dá para mudar dentro desta semana do plano.",
      dia_passado: "Só dá para mudar para hoje ou depois.",
      ja_registrado: "Este treino já foi registrado.",
    },
  },
  workout: {
    watch: "Se você usa relógio de frequência cardíaca",
    studiesTitle: "O que os estudos usaram",
    sourcesTitle: "Base científica deste conselho",
    back: "Voltar ao painel",
    notFound: "Não encontramos este treino.",
    loadError: "Não foi possível carregar o treino.",
    optional: "Complementar",
    ladderTitle: "Etapa {{etapa}} da escada",
    ladderRepeat: "{{reps}} vezes: {{run}} min de corrida e {{walk}} min de caminhada",
    ladderContinuous: "Corrida contínua de {{run}} min",
    todayTitle: "Por que hoje é assim",
    reasonTitle: "Por que este treino",
    howTitle: "Como fazer",
    warmup: "Aquecimento",
    main: "Parte principal",
    cooldown: "Volta à calma",
    intensityTitle: "Intensidade",
    levelTitle: "Para o seu nível",
    limitsTitle: "Limites e cuidados",
    limitsNote: "O app não faz diagnóstico. Se sentir dor que não passa, tontura ou falta de ar fora do normal, pare e procure um profissional de saúde.",
    nextTitle: "Progressão e regressão",
    progression: "Para evoluir",
    regression: "Para aliviar",
    evidenceTitle: "Base científica",
    evidenceDirect: "O que a pesquisa sustenta",
    evidenceProvisional: "Valores iniciais do app",
    evidenceProvisionalHint: "São pontos de partida sensatos, ainda sem estudo direto, e podem ser recalibrados.",
    evidenceInsufficient: "Sem evidência suficiente",
    referencesTitle: "Fontes",
    openSource: "Abrir fonte",
    status: { completed: "Feito", skipped: "Não feito", pending: "Planejado" },
  },
  glossary: {
    title: "Glossário",
    note: "Definições simples, para ajudar a ler o treino.",
    terms: {
      vo2max: { term: "VO2max", text: "A quantidade máxima de oxigênio que o corpo consegue usar por minuto num esforço intenso. É a medida mais usada da capacidade aeróbica." },
      threshold: { term: "Limiar", text: "O ponto de esforço em que a resposta do corpo muda; por exemplo, quando a respiração passa a acelerar. O app usa dois limiares para separar as três zonas (leve, moderada e forte). Existem vários conceitos de limiar e eles diferem entre si (Faude, 2009); por isso o app descreve o limiar por faixa de esforço, e não por um ritmo único." },
      economy: { term: "Economia de corrida", text: "Quanto de energia (oxigênio) você gasta para correr numa certa velocidade. Quanto melhor a economia, menos esforço o corpo faz para o mesmo ritmo." },
      maxHr: { term: "Frequência cardíaca máxima", text: "O maior número de batimentos por minuto que o seu coração atinge num esforço máximo. Pode ser medida (em teste de esforço) ou estimada por fórmula. A estimada erra, em média, cerca de 10 batimentos por minuto; por isso, as faixas em % dela são só uma aproximação." },
      oneRm: { term: "1RM (uma repetição máxima)", text: "A maior carga com que você consegue fazer um exercício uma única vez, com boa técnica. As cargas de força são indicadas como porcentagem dela." },
      effort: { term: "Esforço percebido (0 a 10)", text: "Uma nota que você dá ao esforço do treino, de 0 a 10: 3 é moderado, 5 é difícil e 7 é muito difícil. É a escala CR-10 de Foster." },
      talkTest: { term: "Teste da fala", text: "Fale uma frase em voz alta enquanto corre. Se conseguir sem parar para respirar, o esforço é leve (Z1); se só consegue frases curtas, é moderado (Z2); se não consegue, é forte (Z3)." },
    },
  },
  history: {
    title: "Histórico",
    link: "Histórico",
    loadError: "Não foi possível carregar o histórico.",
    periodLabel: "Período",
    period: "{{weeks}} semanas",
    summaryDone: "Treinos feitos",
    summaryDoneValue: "{{done}} de {{total}}",
    summaryMinutes: "Minutos de treino",
    summaryPace: "Ritmo médio",
    summarySleep: "Sono médio",
    summarySleepValue: "{{hours}} h",
    summaryNone: "—",
    adherenceTitle: "Treinos feitos por semana",
    adherenceHint: "Treinos feitos sobre os treinos previstos até hoje. Os complementares ficam de fora.",
    adherenceReadout: "Semana de {{date}}: {{done}} de {{total}} treinos ({{pct}}%).",
    adherenceEmpty: "Semana de {{date}}: ainda sem treinos previstos.",
    loadTitle: "Carga semanal",
    loadHint: "Esforço percebido (0 a 10) vezes os minutos de cada treino feito, somados na semana. Serve para comparar uma semana com outra; não é uma meta.",
    loadReadout: "Semana de {{date}}: carga {{load}} em {{minutes}} min.",
    loadUnit: "unidades",
    sleepTitle: "Sono",
    sleepHint: "Horas dormidas informadas no check-in de cada dia.",
    sleepReadout: "{{date}}: {{hours}} h de sono.",
    sleepReadoutQuality: "{{date}}: {{hours}} h de sono, qualidade {{quality}} de 5.",
    sleepNoData: "{{date}}: sem check-in com horas de sono.",
    painTitle: "Dor registrada",
    painEmpty: "Nenhuma dor registrada neste período.",
    painIntensity: "intensidade {{value}} de 10",
    moments: { treino: "no treino", manha_seguinte: "na manhã seguinte", checkin: "no check-in" },
    emptyTitle: "Ainda não há histórico",
    emptyText: "Faça o check-in e registre os treinos: os gráficos aparecem aqui.",
    emptyCta: "Ir para o painel",
    showTable: "Ver como tabela",
    tableWeek: "Semana",
    tableDone: "Feitos",
    tablePlanned: "Previstos",
    tableAdherence: "Aderência",
    tableMinutes: "Minutos",
    tableLoad: "Carga",
    tablePace: "Ritmo (min/km)",
    tableDate: "Data",
    tableHours: "Horas",
    tableQuality: "Qualidade",
    painNote: "Registros de dor ajudam a ver padrões, mas não são um diagnóstico. Se a dor persistir ou piorar, procure um profissional de saúde.",
  },
  legal: {
    updated: "Última atualização: {{date}}",
    version: "versão {{version}}",
    toc: "Nesta página",
    back: "Voltar",
    enNotice: "Este texto é uma tradução da versão em português. Se houver diferença entre as duas, vale a versão em português.",
  },
  emailChange: {
    confirmingTitle: "Confirmando seu novo e-mail...",
    doneTitle: "E-mail alterado",
    doneText: "Seu novo e-mail já vale. Por segurança, as sessões foram encerradas: entre de novo com o novo endereço.",
    failTitle: "Link inválido ou expirado",
    failText: "Este link não vale mais. Peça a troca de e-mail de novo em Configurações.",
  },
  review: {
    title: "Como foi este bloco de 2 semanas?",
    text: "Sua resposta serve para cuidar melhor de você: ela pode deixar os próximos treinos mais calmos, nunca mais pesados.",
    options: {
      facil: "Fácil, sobrou energia",
      no_ponto: "No ponto, do jeito certo",
      puxado: "Puxado, cansei mais do que esperava",
      nao_consegui: "Não consegui acompanhar",
    },
    saved: "Resposta registrada.",
    effect: {
      facil: "Que bom! O plano continua do mesmo jeito, sem pular etapas. Se quiser mais, você pode reavaliar seu nível.",
      no_ponto: "Perfeito, o plano continua.",
      puxado: "Vamos com calma: na caminhada e corrida, a próxima semana repete esta etapa. Se sentir dor, registre e procure um profissional.",
      nao_consegui: "Vamos com calma: na caminhada e corrida, a próxima semana repete esta etapa. Se sentir dor, registre e procure um profissional.",
    },
    suggestTitle: "Quer um plano um pouco mais avançado?",
    suggestText:
      "Você disse que o último bloco foi fácil. O plano atual segue sem pular etapas, mas você pode refazer a avaliação: se sua condição permitir, o app indica um ponto de partida mais adiante.",
    suggestCta: "Refazer a avaliação",
    completedTitle: "Você concluiu o plano de {{objective}}",
    completedText:
      "Parabéns pelo trabalho! Para continuar, refaça a avaliação e escolha o próximo objetivo. O app recalcula seu nível com o que você já consegue hoje.",
    completedCta: "Escolher o próximo objetivo",
  },
  nav: {
    label: "Navegação principal",
    menu: "Menu",
    account: "Conta",
    panel: "Painel",
    plan: "Plano de treino",
    history: "Histórico",
    profile: "Perfil e plano",
    settings: "Configurações",
    level: "Nível {{level}}",
    openMenu: "Abrir menu",
    closeMenu: "Fechar menu",
  },
  dash: {
    greetMorning: "Bom dia, {{name}}",
    greetAfternoon: "Boa tarde, {{name}}",
    greetEvening: "Boa noite, {{name}}",
    subtitle: "{{date}} · Semana {{week}} de {{total}} · {{objective}}",
    subtitleShort: "{{date}} · Semana {{week}}",
    stats: {
      distance: "Distância na semana",
      distanceHint: "Soma dos treinos com distância informada",
      distanceNone: "Informe a distância ao registrar um treino",
      time: "Tempo em treino",
      timeHint: "{{done}} de {{total}} treinos feitos",
      pace: "Ritmo médio",
      paceHint: "Dos treinos com distância e duração",
      paceNone: "Aparece quando você informa distância e duração",
      sleep: "Sono médio",
      sleepHint: "Nos últimos 7 dias",
      sleepNone: "Aparece com os check-ins do dia",
    },
    today: { duration: "Duração", zone: "Zona", effort: "Esforço alvo", effortValue: "{{rpe}} de 10", zoneShort: "{{level}} ({{zone}})" },
    volume: {
      title: "Volume semanal",
      done: "Concluído",
      planned: "Planejado",
      minutesDone: "Feitos",
      minutesLeft: "Restantes",
      sessions: "Treinos feitos",
      distance: "Distância",
      chartLabel: "Minutos de treino por dia da semana",
      readout: "{{day}}: {{done}} min feitos de {{planned}} min planejados",
      readoutPlanned: "{{day}}: {{planned}} min planejados",
      readoutRest: "{{day}}: sem treino",
    },
    weekPlan: { title: "Plano da semana", seeAll: "Ver plano completo →", rest: "Descanso", done: "Feito", today: "Hoje", skipped: "Não feito", pending: "Planejado" },
    kinds: {
      rodagem: "Leve",
      qualidade: "Qualidade",
      longao: "Longão",
      regenerativo: "Regenerativo",
      "caminhada-corrida": "Escada",
      forca: "Força",
      mobilidade: "Mobilidade",
    },
    goal: { daysLeft: "dias", weeksLeft: "semanas", currentWeek: "semana atual", progress: "Progresso do plano" },
    recent: { title: "Treinos recentes", seeAll: "Ver histórico", empty: "Os treinos que você registrar esta semana aparecem aqui." },
  },
  healthChange: {
    title: "Mudou algo na sua saúde?",
    text: "Por exemplo: um novo diagnóstico, um remédio novo, uma lesão, uma gravidez ou uma internação. Perguntamos toda semana porque a sua liberação para treinar só vale enquanto a sua saúde estiver como na triagem.",
    no: "Não mudou nada",
    yes: "Sim, algo mudou",
    thanks: "Obrigado pela resposta.",
    thanksText: "Perguntamos de novo em uma semana.",
    confirmTitle: "Vamos refazer a triagem de saúde",
    confirmText: "Seus treinos ficam em espera até você refazer o questionário de saúde (PAR-Q+). É só para o app voltar a liberar você com segurança; não é um diagnóstico. Se for urgente, procure um profissional de saúde.",
    confirmCta: "Confirmar e continuar",
    saving: "Salvando...",
    back: "Voltar",
  },
  plan: {
    title: "Plano completo",
    link: "Plano",
    loadError: "Não foi possível carregar o plano.",
    goalLine: "{{objective}} · {{level}}",
    dates: "De {{start}} a {{end}}",
    tileWeek: "Semana atual",
    tileWeekValue: "{{n}} de {{total}}",
    tileFinished: "Plano concluído",
    tileNotStarted: "Começa em {{date}}",
    tileDone: "Treinos feitos até hoje",
    tileDoneValue: "{{done}} de {{total}}",
    tileEnds: "Termina em",
    note: "As semanas à frente mostram só o contorno do plano. Os treinos de cada uma são montados quando a semana começa, de acordo com o que você fez até lá.",
    noteLadder: "Na escada de caminhada e corrida, uma etapa repetida empurra as semanas seguintes. Por isso a ordem das semanas à frente é uma previsão.",
    weeksTitle: "Semana a semana",
    current: "Semana atual",
    projected: "Previsão",
    noSessions: "Nenhum treino nesta semana.",
  },
  news: {
    bannerTitle: "Novidades do app",
    understood: "Entendi",
    seeAll: "Ver todas as novidades",
    pageTitle: "Novidades",
    pageIntro: "Correções de erros, limitações do app e avisos que valem a pena conhecer.",
    empty: "Ainda não há novidades para você.",
    kind: { correcao: "Correção", limitacao: "Limitação do app", novidade: "Novidade" },
  },
  planNotice: {
    title: "Sua prova está perto demais para este plano",
    needs_one: "Esta distância pede cerca de {{count}} semana de preparo.",
    needs_other: "Esta distância pede cerca de {{count}} semanas de preparo.",
    until_one: "Falta {{count}} semana até a prova.",
    until_other: "Faltam {{count}} semanas até a prova.",
    untilNone: "Não há semanas suficientes até a prova.",
    safety: "Para sua segurança, o app não encurta o plano.",
    choose: "Escolha uma data a partir de {{date}}.",
    chooseWithDistance: "Escolha uma data a partir de {{date}} ou uma distância menor: {{distances}}.",
    or: " ou ",
    distances: { "5k": "5 km", "10k": "10 km", "21k": "21 km" },
    cta: "Refazer a entrevista com outra data",
  },
  pace: { value: "{{pace}} /km" },
  panel: {
    title: "Painel",
    planCta: "Plano completo",
    welcome: "Bem-vindo, {{name}}!",
    hello: "Olá, {{name}}",
    seeProfile: "Ver meu perfil e plano",
    loadError: "Não foi possível carregar o seu painel.",
    todayTitle: "Treino de hoje",
    weekTitle: "Sua semana",
    noPlanTitle: "Ainda não há plano ativo",
    noPlanText: "O plano ainda não foi montado. Veja o resultado da triagem para entender o motivo e o próximo passo.",
    actions: {
      manter: "Treino mantido",
      reduzir: "Treino reduzido",
      regenerativo: "Treino regenerativo",
      descanso_ou_mobilidade: "Descanso ou mobilidade",
      interromper_e_encaminhar: "Pare e procure um profissional",
    },
    rest: "Descanso hoje",
    restPlanned: "Descanso planejado",
    logCta: "Registrar treino",
    logEdit: "Alterar registro do treino",
    detailsCta: "Ver o treino completo",
    restText: "Hoje não há corrida na sua agenda.",
    minutes: "{{count}} min",
    zone: "Até esforço {{level}} ({{zone}})",
    zoneNames: { Z1: "leve", Z2: "moderado", Z3: "forte" },
    rpe: "Esforço alvo: {{rpe}} de 10",
    whyTitle: "Por que hoje é assim",
    complementary: "Complementares de hoje",
    notAllowedToday: "Não recomendado hoje",
    checkinTitle: "Faça o check-in de hoje",
    checkinText: "Leva menos de 30 segundos e ajuda a ajustar o treino do dia.",
    checkinDone: "Check-in de hoje feito.",
    checkinDoneText: "Suas respostas de hoje já estão salvas. Se algo mudou, você pode alterá-las.",
    checkinCta: "Fazer check-in",
    checkinEdit: "Alterar check-in",
    urgent: "Em emergência (dor no peito que não passa, desmaio ou falta de ar intensa), ligue 192 (SAMU).",
    weekNumber: "Semana {{n}}",
    phases: { base: "Base", construcao: "Construção", especifica: "Específica", polimento: "Polimento", prova: "Prova" },
    recoveryWeek: "Semana de recuperação",
    taperWeek: "Semana de polimento",
    raceWeek: "Semana da prova",
    weekDone: "{{done}} de {{total}} treinos feitos",
    weekMinutes: "{{done}} de {{total}} min",
    todayTag: "hoje",
    status: { completed: "Feito", skipped: "Não feito", pending: "Planejado" },
    noSessions: "Sem treino planejado nesta semana.",
    optional: "opcional",
    goalTitle: "Seu objetivo",
    goalPlanEnds: "O plano termina em {{date}}.",
  },
  body: {
    view: "Vista do corpo",
    front: "Frente",
    back: "Costas",
    regions: {
      lombar_sacro: { x: "Lombar / sacro" },
      quadril_virilha: { d: "Quadril / virilha direita", e: "Quadril / virilha esquerda" },
      gluteo: { d: "Glúteo direito", e: "Glúteo esquerdo" },
      coxa_frente: { d: "Coxa (frente) direita", e: "Coxa (frente) esquerda" },
      coxa_atras: { d: "Coxa (parte de trás) direita", e: "Coxa (parte de trás) esquerda" },
      joelho: { d: "Joelho direito", e: "Joelho esquerdo" },
      canela: { d: "Canela direita", e: "Canela esquerda" },
      panturrilha: { d: "Panturrilha direita", e: "Panturrilha esquerda" },
      tendao_aquiles: { d: "Tendão de Aquiles direito", e: "Tendão de Aquiles esquerdo" },
      tornozelo: { d: "Tornozelo direito", e: "Tornozelo esquerdo" },
      pe_dorso: { d: "Pé (parte de cima) direito", e: "Pé (parte de cima) esquerdo" },
      pe_lateral: { d: "Pé (lado de fora) direito", e: "Pé (lado de fora) esquerdo" },
      pe_planta_calcanhar: { d: "Pé (planta e calcanhar) direito", e: "Pé (planta e calcanhar) esquerdo" },
    },
  },
  log: {
    kicker: "Registrar treino",
    didIt: "Você fez este treino?",
    duration: "Duração real (minutos)",
    durationHint: "Some aquecimento, trechos de caminhada e intervalos.",
    plannedTime_one: "Fica registrado o tempo do plano: {{count}} minuto.",
    plannedTime_other: "Fica registrado o tempo do plano: {{count}} minutos.",
    paceLive: "Ritmo médio deste treino: {{pace}} por km. É só uma referência: não é meta.",
    distance: "Distância (km) — opcional",
    srpe: "Como foi o esforço do treino todo?",
    srpeScale: "1 muito muito fácil · 2 fácil · 3 moderado · 4 um pouco difícil · 5 difícil · 7 muito difícil · 10 máximo. Os números 6, 8 e 9 ficam entre os rótulos.",
    painTitle: "Dor durante o treino",
    painHelp: "Toque no local no mapa. Pode marcar mais de um. Se não sentiu dor, deixe sem marcar.",
    noPain: "Nenhum local marcado.",
    painIntensityMissing: "Informe a intensidade da dor de cada local marcado.",
    invalid: "Confira os dados da dor.",
    intensity: "Qual a intensidade da dor?",
    intensityScale: "1 = muito leve · 10 = a pior dor possível.",
    type: "Como é a dor?",
    types: { pontada: "Pontada / aguda", difusa: "Difusa", outra: "Outra" },
    flagsTitle: "Marque o que se aplica a este local",
    flags: {
      suddenOnset: "Começou de repente durante o treino",
      changedStride: "A dor mudou a minha passada (mancar, compensar, evitar apoiar um lado)",
      worsensEachStrideOrNoWarmup: "Piora a cada passada ou não melhora com o aquecimento",
      bonePoint: "Dói em um ponto do osso (ao tocar ou ao apoiar)",
      restOrNightPain: "Dói em repouso ou à noite",
      painWalking: "Dói ao caminhar",
      jointSwelling: "Há inchaço visível na articulação",
      lockingOrGivingWay: "A articulação trava, prende ou cede",
      tinglingOrNumbness: "Há formigamento ou dormência",
      suddenWeaknessOrFootDrop: "Perdi força de repente ou o pé caiu",
      darkUrineWithMuscleSwelling: "Urina escura (cor de chá) com dor muscular intensa ou inchaço",
      analgesicBeforeTraining: "Tomei analgésico ou anti-inflamatório antes do treino",
    },
    removeRegion: "Remover",
    symptomsTitle: "Sintomas durante ou depois do treino",
    symptomsHelp: "Marque se sentiu algum. Se não sentiu nenhum, deixe em branco.",
    cardio: {
      chestPain: "Dor ou aperto no peito",
      disproportionateBreathlessness: "Falta de ar desproporcional ao esforço",
      dizzyLosingBalance: "Tontura com perda de equilíbrio",
      fainting: "Desmaio ou quase desmaio",
      palpitations: "Palpitações irregulares",
    },
    heat: {
      confusionOrCollapse: "Confusão, desorientação ou colapso",
      headacheNauseaInHeat: "Dor de cabeça, tontura, náusea ou vômito no calor",
    },
    notes: "Comentário (opcional)",
    submit: "Salvar registro",
    notSaved: "Ainda não salvamos. Falta responder:",
    distanceInvalid: "Distância (use só números, como 5,2)",
    saving: "Salvando...",
    cancel: "Cancelar",
    notFound: "Não encontramos este treino.",
    backToPanel: "Voltar ao painel",
    doneTitle: "Registro salvo",
    nextDayTitle: "O que muda para amanhã",
    referNote: "Pelo que você registrou, procure um profissional de saúde antes de voltar a correr. O app não faz diagnóstico.",
    disclaimer: "O app não faz diagnóstico: se a dor ou o sintoma não passar, procure um profissional de saúde.",
  },
  reminder: {
    title: "Lembrete do treino",
    text: "Um aviso neste aparelho quando tiver treino.",
    day: "Quando avisar",
    days: { mesmo_dia: "No dia do treino", vespera: "Na véspera" },
    time: "Horário",
    hour: "Hora",
    minute: "Minutos",
    turnOn: "Ligar lembrete",
    save: "Salvar",
    off: "Desligar",
    on: { mesmo_dia: "Ligado: no dia do treino, às {{time}}.", vespera: "Ligado: na véspera do treino, às {{time}}." },
    saved: "Lembrete salvo.",
    blocked: "As notificações estão bloqueadas para este site. Para receber o lembrete, libere nas configurações do navegador.",
    unsupported: "Este navegador não recebe notificações.",
    iosInstall: "No iPhone e no iPad, o lembrete só funciona com o app instalado na tela inicial (veja Instalar no celular).",
    privacy: "O aviso não traz dado de saúde e passa pelo serviço de notificações do navegador.",
  },
  install: {
    title: "Instalar no celular",
    text: "Instale o Let's Go Run na tela inicial para abrir como um app, sem a barra do navegador.",
    button: "Instalar o app",
    ios: "No iPhone ou iPad: toque em Compartilhar, no Safari, e depois em Adicionar à Tela de Início.",
    other: "No menu do navegador, procure Instalar ou Adicionar à tela inicial.",
    installed: "O app já está instalado neste aparelho.",
    offline: "Sem internet o app abre, mas só mostra e salva os seus dados quando a conexão voltar.",
    offlineNotice: "Sem internet. Nada é salvo até a conexão voltar.",
  },
  weekSummary: {
    title: "Como foi a semana {{n}}",
    subtitle: "Resumo do que você registrou.",
    sessions: "Treinos feitos",
    sessionsValue: "{{done}} de {{total}}",
    time: "Tempo em treino",
    distance: "Distância",
    km: "{{km}} km",
    pace: "Ritmo médio",
    paceValue: "{{pace}} /km",
    sleep: "Sono médio",
    hours: "{{hours}} h",
    pain: "Dor",
    painDays_one: "{{count}} dia",
    painDays_other: "{{count}} dias",
    painNone: "Nenhuma registrada",
  },
  quickLog: {
    open: "Registrar: {{name}}",
    openLogged: "Ver o registro: {{name}}",
    did: "Fiz",
    didNot: "Não fiz",
    full: "Abrir o registro completo",
    markedDone: "Você fez este treino.",
    markedSkipped: "Você não fez este treino.",
    unwell: "Sentiu dor ou algum mal-estar?",
    unwellSkipped: "Deixou de treinar por dor ou mal-estar?",
    unwellHint: "Por exemplo: dor em algum lugar, aperto no peito, tontura, falta de ar ou mal-estar no calor.",
    goFull: "Conte os detalhes no registro completo. Lá você marca onde doeu e o que sentiu.",
    continueFull: "Continuar no registro completo",
    wasDone: "Você marcou este treino como feito.",
    wasSkipped: "Você marcou este treino como não feito.",
    editHint: "Para mudar, abra o registro. Ele já vem com o que você informou, inclusive a dor.",
    missing_one: "{{count}} treino desta semana ficou sem registro. Toque no círculo para dizer se fez ou não.",
    missing_other: "{{count}} treinos desta semana ficaram sem registro. Toque no círculo para dizer se fez ou não.",
    back: "Voltar",
    close: "Fechar",
  },
  checkin: {
    title: "Check-in de hoje",
    text: "Menos de 30 segundos. Pode pular o que não souber.",
    sleepHours: "Quantas horas você dormiu esta noite?",
    sleepHint: "Pode usar decimais, como 7,5.",
    sleepQuality: "Como foi a qualidade do sono?",
    energy: "Como está a sua energia?",
    mood: "Como está o seu humor?",
    stress: "Como está o estresse hoje?",
    soreness: "Como estão os seus músculos?",
    scale: "1 = {{low}} · 5 = {{high}}",
    low: { sleepQuality: "Péssima", energy: "Sem energia", mood: "Ruim", stress: "Muito estressado", soreness: "Muita dor muscular" },
    high: { sleepQuality: "Ótima", energy: "Cheio de energia", mood: "Ótimo", stress: "Tranquilo", soreness: "Sem dor" },
    restingHr: "Frequência cardíaca de repouso (opcional)",
    restingHrHint: "Em batimentos por minuto, ao acordar.",
    illness: "Você está com febre ou resfriado hoje?",
    painWalking: "Qual a intensidade da dor ao caminhar no dia a dia?",
    painWalkingHint: "0 = nenhuma dor; 10 = a pior dor possível.",
    submit: "Salvar check-in",
    saving: "Salvando...",
    back: "Voltar ao painel",
    errors: "Confira os valores destacados.",
  },
} as const;

type Widen<T> = T extends string ? string : { [K in keyof T]: Widen<T[K]> };
export type Translation = Widen<typeof ptBR>;
